// extracted by mini-css-extract-plugin
module.exports = {"BackgroundPanel":"CardBackgroundPanel_BackgroundPanel__1xAA3"};